import React from 'react';
import { getProjectDetail } from '@gtintel/platform-api';
import { DocumentTab } from '@gtintel/platform-doclib';
import { LegacyComponentContainer } from './Container';
export const LegacyDocumentsContainer = ({
  id
}) => {
  const [project, setProject] = React.useState(null);
  React.useEffect(() => {
    getProjectDetail(`${id}`).then(res => {
      const project = {
        ...res,
        statusDetail: res.status,
        typeBatch: res.source
      };
      setProject(project);
    }).catch(console.error);
  }, [id]);
  if (!project) return null;
  return <LegacyComponentContainer>
      <DocumentTab project={project} chatFilesReadonly />
    </LegacyComponentContainer>;
};